import { render, staticRenderFns } from "./RegionStoreSelector.vue?vue&type=template&id=36909b6c&scoped=true"
import script from "./RegionStoreSelector.vue?vue&type=script&lang=js"
export * from "./RegionStoreSelector.vue?vue&type=script&lang=js"
import style0 from "./RegionStoreSelector.vue?vue&type=style&index=0&id=36909b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36909b6c",
  null
  
)

export default component.exports